import pivotreeLogo from './pivotree-logo-white.png';

export const LogoFull = () => (
  <img
    src={pivotreeLogo}
    alt="Pivotree"
    style={{ height: 32, width: 'auto', display: 'block' }}
  />
);
